import { render, staticRenderFns } from "./feedback-request.vue?vue&type=template&id=139535b2&scoped=true&"
import script from "./feedback-request.vue?vue&type=script&lang=js&"
export * from "./feedback-request.vue?vue&type=script&lang=js&"
import style0 from "./feedback-request.vue?vue&type=style&index=0&id=139535b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139535b2",
  null
  
)

export default component.exports